import {
	Component,
	OnInit,
	OnDestroy,
	HostBinding,
	HostListener,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LoaderService } from "./loader.service";
import { LoaderState } from "./loader.state";
@Component({
	selector: "progress-loader",
	templateUrl: "loader-animation.directive.html",
	styleUrls: ["loader-animation.directive.css"],
})
export class LoaderAnimationDirective implements OnInit {
	show = false;
	private subscription: Subscription;
	@HostBinding("style.height") height: string;
	constructor(private loaderService: LoaderService) {
		this.subscription = this.loaderService.loaderState$.subscribe(
			(state: LoaderState) => {
				this.show = state.show;
				this.height = "100%";
				if (state.show === false) {
					this.height = "0%";
					this.ngOnDestroy();
				}
			}
		);
	}
	ngOnInit() {}
	ngOnDestroy() {
		// this.subscription.unsubscribe();
		console.log("loader subscription destroy");
	}
}
